export const getStatus = (id: any, status: any) => {
  const filter = status.filter((status: any) => status.id === id)[0];
  return filter;
};
